/* eslint-disable react/forbid-elements */
import { createIcon, type ISVGIconProps, type ISVGProps } from '@cian/ui-kit-design-tokens/internal';
import * as React from 'react';

// eslint-disable-next-line react/display-name
const IconComponent = React.forwardRef((props: ISVGProps, ref: React.Ref<SVGSVGElement>) => {
  return (
    <svg {...props} ref={ref} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M19.88 8.466a2.456 2.456 0 10-3.474-3.474 2.456 2.456 0 003.474 3.474zm-.856-.828a1.247 1.247 0 11-1.764-1.764 1.247 1.247 0 011.764 1.764z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M20.056 8.643a2.706 2.706 0 000-3.828l-.353.354a2.206 2.206 0 010 3.12l.354.354zm0-3.828a2.706 2.706 0 00-3.827 0l.354.354a2.206 2.206 0 013.12 0l.354-.354zm-3.827 0a2.706 2.706 0 000 3.828l.354-.354a2.206 2.206 0 010-3.12l-.354-.354zm0 3.828a2.706 2.706 0 003.828 0l-.354-.354a2.206 2.206 0 01-3.12 0l-.354.354zm2.619-1.182a.997.997 0 01-1.41 0l-.354.353a1.497 1.497 0 002.117 0l-.354-.353zm-1.41 0a.997.997 0 010-1.41l-.354-.354a1.497 1.497 0 000 2.117l.353-.353zm0-1.41a.997.997 0 011.41 0l.353-.354a1.497 1.497 0 00-2.117 0l.353.354zm1.41 0a.998.998 0 010 1.41l.353.353a1.497 1.497 0 000-2.117l-.354.354z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.993 10.57l.7.63 2.522-2.8 1.568 1.413c.377.339.65.68.822 1.021.17.342.261.674.273.995a2.1 2.1 0 01-.177.925 2.978 2.978 0 01-1.264 1.404 2.07 2.07 0 01-.887.256 2.34 2.34 0 01-1.006-.18c-.353-.14-.718-.38-1.095-.719l-.472-.425-.577.641 1.484 1.337-.782.868L9.618 14.6l-.623.691-1.097-.987.623-.691-.7-.63.782-.87.7.63.578-.64-.7-.63.812-.903zm2.16 1.944c.151.137.305.252.46.346.155.093.313.152.475.176a.9.9 0 00.49-.07c.166-.07.334-.201.506-.392.173-.191.289-.377.349-.557a.994.994 0 00.04-.52 1.25 1.25 0 00-.205-.476 2.508 2.508 0 00-.384-.43l-.363-.326-1.731 1.923.362.326z"
        clipRule="evenodd"
      />
      <path
        stroke="currentColor"
        strokeWidth="2"
        d="M9.35 22.358l-6.885-6.402a2 2 0 01-.103-2.827L12.66 2.053a2 2 0 011.5-.638l6.233.114a2 2 0 011.961 1.904l.318 6.65a2 2 0 01-.533 1.457l-9.962 10.715a2 2 0 01-2.826.103z"
      />
    </svg>
  );
});

export const IconFlatValuation24: React.FC<ISVGIconProps> = createIcon(IconComponent);
